const SHOPIFY_DOMAIN = "fetch-revival.myshopify.com";
const API_BASE_URL = "https://api.fetcheyewear.com";
const STORE_FRONT_ACCESS_TOKEN = "263baefbbb48c7d1c504656cb4c5f09d";
const ADMIN_ACCESS_TOKEN = "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";
const API_KEY = "1fd718fbf5421ecb386e20e6589bd8d9";
const API_SECRET_KEY = "531c790504d32b8b7e84b081ca277853";
const BASE_URL = "https://fetcheyewear.local";
let selectedDiscounts = [];
let fetchPrescriptionPriceList = [];

if (performance.navigation.type == 2) {
    location.reload(true);
}

$(".pick-frame .product-grid .product-item input[type=radio]").on(
    "change",
    function () {
        let _this = $(this);
        $("#step1 .back-bttn").addClass("changed");
        $('.try-it').removeClass('disabled');
        // if ($("#step1 .back-bttn").hasClass("changed")) {
        //   $("#step1 .back-bttn").removeClass("changed").addClass("no-change");
        // } else {
        //   $("#step1 .back-bttn").removeClass("no-change").addClass("changed");
        // }
    }
);

// Next step function
async function nextStep(currentStep) {
    console.log("Next Step: " + currentStep);
    let screen_one = $("#shopify-section-versatility-step1");
    let screen_two = $("#shopify-section-convenience-step2");
    let screen_three = $("#shopify-section-both-step3");

    if (currentStep === 1) {

        $('.lens-list').empty();

        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {

                if (cart.items.length < 1) {
                    // sessionStorage.clear();
                    localStorage.removeItem("fetchildisid");
                    localStorage.removeItem("fetchildiscode");
                    localStorage.removeItem("fetchildisvalue");
                }
            })
            .catch(error => console.error('Error fetching cart:', error));

        let step2 = $("#step2");
        let frameValue = $('input[name="collection"]');
        let selectedFrameValue = $('input[name="collection"]:checked');
        console.log("frameValue", frameValue);
        console.log("selectedFrameValue", selectedFrameValue);
        if (frameValue.is(":checked")) {
            console.log("frameValue is checked");
            if ($("#step1 .back-bttn").hasClass("changed")) {
                console.log("back button changed");
                let productId = `gid://shopify/Product/${selectedFrameValue.data(
                    "pid"
                )}`;
                let variantId = `gid://shopify/ProductVariant/${selectedFrameValue.data(
                    "vid"
                )}`;
                console.log("productId", productId);
                console.log("variantId", variantId);
                let productData = await fetchProductById(productId);
                console.log("productData", productData);
                let variantData = productData.variants.edges;
                let input_type = $("#shopify-section-convenience-step2").length
                    ? "radio"
                    : "checkbox";

                console.log("productData", productData);
                // console.log(productData.variants);
                // console.log(productData.variants.edges);

                $(".product-select-color").empty();
                $(".color-options").remove();
                $(".p-title, .p-color-title").text(productData.title);
                $("#step2 .para16 p").text(productData.description);

                for (const key in variantData) {
                    if (Object.prototype.hasOwnProperty.call(variantData, key)) {
                        const variant = variantData[key].node;
                        const stockStatus = variant.availableForSale ? '' : 'variant_sold_out';
                        const variantHtml = `
              <div class="p-select-color ${stockStatus}">
                <div class="product-select-img pro-popup" data-scale="1.3">
                  <span class="pro-icon">
                      <svg class="icon icon-search" fill="none" viewBox="0 0 18 19">
                          <path clip-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" fill="currentColor" fill-rule="evenodd">
                          </path>
                      </svg>
                  </span>
                  <img class="img_producto" src="${variant.image.src}" alt="${variant.image.altText
                            }">
                </div>
                <div class="c-box">
                  <label class="checkbox">${variant.title}
                    <input type="${input_type}" name="product_variants" value="${variant.id
                            }" data-price="${parseFloat(variant.price.amount).toFixed(
                                2
                            )}" data-title="${variant.title}" ${variant.id === variantId ? "checked" : ""
                            } data-sku="${variant.sku}">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>`;

                        $(".product-select-color").append(variantHtml);

                        if (variant.id === variantId) {
                            const optionsHtml = `<li class="color-options" data-optionId="${variant.id
                                }">
                <div>
                  <span>${variant.title}</span>
                </div>
                <div>
                  <span class="c-price">$${parseFloat(
                                    variant.price.amount
                                ).toFixed(2)}</span>
                </div>
              </li>`;

                            $(".perf-img img").attr({
                                src: variant.image.src,
                                alt: variant.image.altText,
                            });

                            $(".frame-price, .total-price").text(
                                `$${parseFloat(variant.price.amount).toFixed(2)}`
                            );
                            $(".step-total-price")
                                .val(parseFloat(variant.price.amount).toFixed(2))
                                .attr(
                                    "data-extra",
                                    parseFloat(variant.price.amount).toFixed(2)
                                );
                            $(".price-box-list>ul").append(optionsHtml);
                        }
                    }
                }
            }
            modal_fn();
            // Append options and update price
            step2.find('input[name="product_variants"]').on("change", function () {
                let _this = $(this);
                let optionTitle = _this.data("title");
                let optionPrice = _this.data("price");
                let optionVal = _this.val();
                let updTotalPrice = "";
                let optionArr = [];

                // Check all options is checked or not
                $('input[name="product_variants"]').each(function (i, v) {
                    if ($(v).is(":checked")) {
                        optionArr.push(true);
                    }
                });

                // Atleast two options select condition
                if (
                    $("#shopify-section-versatility-step1").length ||
                    $("#shopify-section-both-step3").length
                ) {
                    if (optionArr.length == 0) {
                        $(".frame-price").text("$0.00");
                        // step2.find("button.next").addClass("disabled");
                    } else if (optionArr.length == 1) {
                        optionPrice = step2
                            .find('input[name="product_variants"]:checked')
                            .data("price");
                        $(".frame-price").text(`$${optionPrice}`);
                        $(".pick-perfect .perf-img img").attr(
                            "src",
                            step2
                                .find('input[name="product_variants"]:checked')
                                .parents()
                                .eq(2)
                                .find("img")
                                .attr("src")
                        );
                        updTotalPrice = parseFloat(optionPrice).toFixed(2);
                        $(".step-total-price")
                            .val(updTotalPrice)
                            .attr("data-extra", updTotalPrice);
                        $(".total-price").text(`$${updTotalPrice}`);
                        // step2.find("button.next").removeClass("disabled");
                        // step2.find("button.next").addClass("disabled");
                    } else {
                        // step2.find("button.next").removeClass("disabled");
                    }
                } else {
                    if (optionArr.length == 0) {
                        $(".frame-price").text("$0.00");
                        // step2.find("button.next").addClass("disabled");
                    } else if (optionArr.length == 1) {
                        optionPrice = step2
                            .find('input[name="product_variants"]:checked')
                            .data("price");
                        $(".frame-price").text(`$${optionPrice}`);
                        $(".pick-perfect .perf-img img").attr(
                            "src",
                            step2
                                .find('input[name="product_variants"]:checked')
                                .parents()
                                .eq(2)
                                .find("img")
                                .attr("src")
                        );
                        updTotalPrice = parseFloat(optionPrice).toFixed(2);
                        $(".step-total-price")
                            .val(updTotalPrice)
                            .attr("data-extra", updTotalPrice);
                        $(".total-price").text(`$${updTotalPrice}`);
                        // step2.find("button.next").removeClass("disabled");
                    } else {
                        // step2.find("button.next").removeClass("disabled");
                    }
                }

                if (_this.is(":checked")) {
                    let updatedOptionHtml = `<li class="color-options" data-optionid="${optionVal}">
                                      <div>
                                        <span>${optionTitle}</span>
                                      </div>
                                      <div>
                                        <span class="c-price">$${optionPrice}</span>
                                      </div>
                                    </li>`;

                    if (updTotalPrice == "") {
                        updTotalPrice = (
                            parseFloat(optionPrice) + parseFloat($(".step-total-price").val())
                        ).toFixed(2);
                    }

                    if (screen_two.length) {
                        // Convenience Screen
                        if (step2.find(".color-options:last-child").length == 0) {
                            $(updatedOptionHtml).insertAfter(
                                $(".price-box-list ul li:last-child")
                            );
                            $(".price-box-list ul li:nth-last-child(2)").remove();
                        } else {
                            $(updatedOptionHtml).insertAfter($(".color-options:last-child"));
                            $(".color-options:nth-last-child(2)").remove();
                        }
                    } else if (screen_three.length) {
                        // Both Screen
                        if (step2.find(".color-options:last-child").length == 0) {
                            $(updatedOptionHtml).insertAfter(
                                $(".price-box-list ul li:last-child")
                            );
                        } else {
                            $(updatedOptionHtml).insertAfter($(".color-options:last-child"));
                        }
                    } else {
                        // Versatility Screen
                        if (step2.find(".color-options:last-child").length == 0) {
                            $(updatedOptionHtml).insertAfter(
                                $(".price-box-list ul li:last-child")
                            );
                        } else {
                            $(updatedOptionHtml).insertAfter($(".color-options:last-child"));
                        }
                    }

                    // Show last selected option image
                    $(".pick-perfect .perf-img img").attr(
                        "src",
                        _this.parents().eq(2).find("img").attr("src")
                    );
                } else {
                    if (updTotalPrice == "") {
                        updTotalPrice = (
                            parseFloat($(".step-total-price").val()) - parseFloat(optionPrice)
                        ).toFixed(2);
                    }
                    $('li[data-optionid="' + _this.val() + '"]').remove();
                }

                $(".step-total-price")
                    .val(updTotalPrice)
                    .attr("data-extra", updTotalPrice);
                $(".total-price").text(`$${updTotalPrice}`);
            });

            $("#step1 .back-bttn").removeClass("changed").addClass("no-change");
        } else {
            return errorModal("Please select a frame style");
        }

        discountFunctionality();
    }

    if (currentStep === 2) {
        console.log("Step 2: " + currentStep);

        let productVariants = $('#step2 input[name="product_variants"]:checked');
        console.log("productVariants", productVariants);
        console.log("productVariants", productVariants.length);

        if ($("#shopify-section-versatility-step1").length || $("#shopify-section-both-step3 .lens-box").length) {
            if (productVariants.length < 2) {
                return errorModal("Please choose at least two colors before moving on to the next step.");
            }

        }

        // if ($("#shopify-section-both-step3 .lens-box").length) {
        //   console.log("both .............................!");
        // } else {
        //   console.log("both else .............................!");

        // }

        let step3 = $("#step3");

        // // File selection
        // $(document).on("click", ".file-label", function () {
        //   $(this).next("input").click();
        // });

        $(document).on("change", ".file-input", function (event) {
            console.log("file input change event triggered");
            let _this = $(this);
            let parent = _this.parent();
            let file = event.target.files[0];

            if (file) {
                // Validate for the file format, should be a image file format
                if (!file.type.startsWith("image/")) {
                    alert("Please upload a file with a valid image format. For Example JPEG, PNG.");
                    _this.val("");
                    return;
                }

                $(`<div class="img-view">
            <div>
                <span>${file.name}</span>
            </div>
            <button type="button" class="img-remove"><i class="fa fa-times" aria-hidden="true"></i></button>
        </div>`).insertBefore(parent.find("label"));

                // Create a FormData object to send the file via API
                let formData = new FormData();
                formData.append("file", file);

                // Make the API request to upload the file
                $.ajax({
                    url: `${BASE_URL}/wp-json/shopify/v1/upload-file`,
                    method: "POST",
                    data: formData,
                    contentType: false,
                    processData: false,
                    success: function (response) {
                        // Ensure response has the expected structure
                        if (response.file_url) {
                            // File uploaded successfully, display the preview
                            $(`<div class="img-view">
                          <div>
                              <img src="${response.file_url}" alt="${file.name}" />
                              <span>${file.name}</span>
                          </div>
                          <button type="button" class="img-remove"><i class="fa fa-times" aria-hidden="true"></i></button>
                      </div>`).insertBefore(parent.find("label"));
                        } else {
                            console.log("File upload failed. Please try again.");
                        }
                    },
                    error: function (xhr, status, error) {
                        console.log("Error uploading the file. Please try again.");
                    },
                });
            }
        });

        // Handle remove button click
        $(document).on("click", ".img-remove", function () {
            console.log("remove button clicked");
            const _this = $(this);
            // _this.parent().find('img').attr("src", "");
            _this.parent().parent().find("input").val("");
            _this.parent().remove();
        });

        /**
        * Script for adding more lenses
        */
        // $(document).on("click", ".add-more-lenses", async function () {
        //   console.log("add more lenses clicked");
        //   let _this = $(this);
        //   let lens_box_parent = _this.parents().eq(3);
        //   let lens_btn_parent = _this.parent().parent();
        //   let step_count = lens_btn_parent.find(".lens-add").children().length;

        //   $(".lens-box").removeClass('active');
        //   let duplicate = $(".lens-box").first().clone();
        //   duplicate.addClass('active');
        //   duplicate.find("select").prop("selectedIndex", 0);
        //   duplicate.find("input[type='checkbox']").prop("checked", false);
        //   duplicate.find("input[type='file']").val("");
        //   duplicate.find(".selctd-vlue").text("");
        //   duplicate.find(".fil-sec-tab.active").removeClass("active");
        //   duplicate.find(".optical-lens-sec").addClass("fil-d-none");
        //   duplicate.find(".suns-lens-sec").addClass("fil-d-none");
        //   $(".lens-box").last().after(duplicate);

        //   // Remove active class from previous boxes and append new one
        //   lens_box_parent.find(".lens-box").removeClass("active");
        //   $(duplicate).addClass('active');

        //   // Update step indicators
        //   lens_btn_parent.find(".lens-add span").removeClass("active");
        //   lens_btn_parent.find(".lens-add")
        //     .append(
        //       `<span class="active" data-lens-step="${step_count + 1}">
        //       <div class="close-icon">✖</div>
        //       ${step_count + 1
        //       }</span>`
        //     );
        // });

        // Click handler for the close icon (prevents parent span click)
        $(document).on(
            "click",
            ".lens-form .form-group .lens-added .lens-add span .close-icon",
            function (e) {
                e.stopPropagation(); // Stops the event from reaching the parent span
                // Your existing close icon logic here
            }
        );

        // Lens step
        $(document).on(
            "click",
            ".lens-form .form-group .lens-added .lens-add span",
            function () {
                let _this = $(this);
                let step_number = _this.data("lens-step");
                _this.parent().find("span").removeClass("active");
                _this.addClass("active");

                $(".lens-box").removeClass("active");
                $(`.lens-box:nth-child(${step_number})`).addClass("active");
            }
        );


        jQuery(document).on(
            "click",
            ".lens-form .form-group .lens-added .lens-add span .close-icon",
            function () {
                let _this = jQuery(this);
                let step_number = _this.parent().data("lens-step");

                // Remove the lens box
                jQuery(`.lens-box:nth-child(${step_number})`).remove();

                // Remove the clicked lens indicator
                _this.parent().remove();

                // Get all remaining lens indicators
                let lensIndicators = jQuery(".lens-form .form-group .lens-added .lens-add span");

                // Re-sequence the remaining indicators
                lensIndicators.each(function (index) {
                    let newStepNumber = index + 1;
                    let spanContent = (newStepNumber === 1)
                        ? newStepNumber  // First span: No close icon
                        : '<div class="close-icon">✖</div>' + newStepNumber; // Others: Keep close icon

                    jQuery(this)
                        .attr("data-lens-step", newStepNumber)
                        .html(spanContent);
                });

                // Make the first lens box active
                jQuery(".lens-box").removeClass("active");
                jQuery(".lens-box:nth-child(1)").addClass("active");

                // Make the first indicator active
                jQuery(".lens-form .form-group .lens-added .lens-add span").removeClass("active");
                jQuery(".lens-form .form-group .lens-added .lens-add span:nth-child(1)").addClass("active");
                setTimeout(() => {
                    console.log("hello")
                    updatePrescriptionList();
                    displaySelectedItems();
                    updateTotalPrice();
                }, 200);
            }
        );

        applyDiscounts(selectedDiscounts, 'step3');
    }

    // Add to Cart Functionality
    /* $("#add-to-cart").on("click", function () {
      let productVariants = $('#step2 input[name="product_variants"]');
      let variants = [];
  
      // List of variants to add
      productVariants.each(function (i, v) {
        if ($(this).is(":checked")) {
          variants.push({
            id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
            quantity: 1,
            properties: {
              "Prescription File": "File 1",
              "PD Measurement Photo": "File 2",
            },
          });
        }
      });
  
      // Prepare the payload
      var data = {
        items: variants.map((variant) => ({
          id: variant.id,
          quantity: variant.quantity,
          properties: variant.properties,
        })),
      };
  
      // Send a single request to add all variants
      $.ajax({
        url: "/cart/add.js",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function (response) {
          console.log("Variants added:", response);
        },
        error: function (xhr, status, error) {
          // console.error("Error adding variants:", xhr.responseText);
        },
      });
    }); */

    /* $("#add-to-cart").on("click", function () {
      let productVariants = $('#step2 input[name="product_variants"]');
      let variants = [];
  
      // Initialize file URLs
      let prescriptionFileUrl = "";
      let pdMeasurementFileUrl = "";
  
      // Get the uploaded file and create the image URL if a file is selected
      let prescriptionFile = $("#prescription-file")[0].files[0];
      let pdMeasurementFile = $("#pd-measurement-photo")[0].files[0];
  
      // Handle Prescription File
      if (prescriptionFile) {
        prescriptionFileUrl = URL.createObjectURL(prescriptionFile);
        // Show the preview and link dynamically
        let prescriptionPreview = $("<img>")
          .attr("src", prescriptionFileUrl)
          .css("width", "200px");
        let prescriptionLink = $("<a>")
          .attr("href", prescriptionFileUrl)
          .attr("target", "_blank")
          .text("Open Prescription File");
  
        // Append preview and link to the page
        $("#prescription-file-container")
          .html(prescriptionPreview)
          .append(prescriptionLink);
      } else {
        $("#prescription-file-container").html(""); // Clear the container if no file is selected
      }
  
      // Handle PD Measurement File
      if (pdMeasurementFile) {
        pdMeasurementFileUrl = URL.createObjectURL(pdMeasurementFile);
        // Show the preview and link dynamically
        let pdMeasurementPreview = $("<img>")
          .attr("src", pdMeasurementFileUrl)
          .css("width", "200px");
        let pdMeasurementLink = $("<a>")
          .attr("href", pdMeasurementFileUrl)
          .attr("target", "_blank")
          .text("Open PD Measurement File");
  
        // Append preview and link to the page
        $("#pd-measurement-file-container")
          .html(pdMeasurementPreview)
          .append(pdMeasurementLink);
      } else {
        $("#pd-measurement-file-container").html(""); // Clear the container if no file is selected
      }
  
      // List of variants to add
      productVariants.each(function (i, v) {
        if ($(this).is(":checked")) {
          variants.push({
            id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
            quantity: 1,
            properties: {
              "Prescription File": prescriptionFileUrl || "File 1", // Use file URL or default
              "PD Measurement Photo": pdMeasurementFileUrl || "File 2", // Use file URL or default
            },
          });
        }
      });
  
      // Prepare the payload
      var data = {
        items: variants.map((variant) => ({
          id: variant.id,
          quantity: variant.quantity,
          properties: variant.properties,
        })),
      };
  
      // Send a single request to add all variants
      $.ajax({
        url: "/cart/add.js",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function (response) {
          console.log("Variants added:", response);
        },
        error: function (xhr, status, error) {
          // console.error("Error adding variants:", xhr.responseText);
        },
      });
    }); */

    /* $("#add-to-cart").on("click", function () {
      let productVariants = $('#step2 input[name="product_variants"]');
      let variants = [];
  
      // Get the uploaded file URL
      let prescriptionFileUrl = $("#prescription-file")[0].files[0]
        ? URL.createObjectURL($("#prescription-file")[0].files[0])
        : "";
      let pdMeasurementFileUrl = $("#pd-measurement-photo")[0].files[0]
        ? URL.createObjectURL($("#pd-measurement-photo")[0].files[0])
        : "";
  
      // List of variants to add
      productVariants.each(function (i, v) {
        if ($(this).is(":checked")) {
          variants.push({
            id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
            quantity: 1,
            properties: {
              "Prescription File": prescriptionFileUrl || "File 1", // Use the uploaded file URL or a default placeholder
              "PD Measurement Photo": pdMeasurementFileUrl || "File 2", // Use the uploaded file URL or a default placeholder
            },
          });
        }
      });
  
      // Prepare the payload
      var data = {
        items: variants.map((variant) => ({
          id: variant.id,
          quantity: variant.quantity,
          properties: variant.properties,
        })),
      };
  
      // Send a single request to add all variants
      $.ajax({
        url: "/cart/add.js",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function (response) {
          console.log("Variants added:", response);
        },
        error: function (xhr, status, error) {
          // console.error("Error adding variants:", xhr.responseText);
        },
      });
    }); */

    /* $("#add-to-cart").on("click", function () {
      if ($("#shopify-section-versatility-step1").length) {
        let productVariants = $('#step2 input[name="product_variants"]');
        let prescriptionLensTypeVariants = $(".prescription-lens-type option");
        let nonPrescriptionLensTypeVariants = $(
          ".non-prescription-readers option"
        );
        let addonsVariants = $(".lens-addons input");
        let variants = [];
        let fileUrls = {}; // To store the URLs of uploaded files
  
        // Addons Variants add in list
        addonsVariants.each(function (i, v) {
          if ($(v).is(":checked") && $(v).val() != "") {
            variants.push({
              id: $(v).val(),
              quantity: 1,
            });
          }
        });
  
        // Non Prescription Lens Type Variants add in list
        nonPrescriptionLensTypeVariants.each(function (i, v) {
          if ($(v).is(":checked") && $(v).val() != "") {
            variants.push({
              id: $(v).val(),
              quantity: 1,
            });
          }
        });
  
        // Prescription Lens Type Variants add in list
        prescriptionLensTypeVariants.each(function (i, v) {
          if ($(v).is(":checked") && $(v).val() != "") {
            variants.push({
              id: $(v).val(),
              quantity: 1,
            });
          }
        });
  
        // List of variants to add
        productVariants.each(function (i, v) {
          if ($(this).is(":checked")) {
            variants.push({
              id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
              quantity: 1,
            });
          }
        });
  
        // Check if prescription file is selected
        let prescriptionFile = $(".prescription-file")[0].files[0];
        if (prescriptionFile) {
          uploadFile(prescriptionFile, "prescription-file");
        }
  
        // Check if PD measurement photo is selected
        let pdMeasurementFile = $(".pd-measurement-photo")[0].files[0];
        if (pdMeasurementFile) {
          uploadFile(pdMeasurementFile, "pd-measurement-photo");
        }
  
        // Function to upload files to WordPress backend, which then sends them to Shopify
        function uploadFile(file, fileType) {
          let formData = new FormData();
          formData.append("file", file);
          formData.append("action", "shopify_file_upload");
  
          $.ajax({
            url: "http://3.130.97.36:8892/wp-json/shopify/v1/upload-file", // Your WordPress REST API endpoint
            type: "POST",
            data: formData,
            cache: false,
            processData: false,
            contentType: false,
            enctype: "multipart/form-data",
            success: function (response) {
              // Store the file URL in the fileUrls object if upload is successful
              if (response.file_url) {
                fileUrls[fileType] = response.file_url;
              }
  
              // After uploading both files, proceed with adding to the cart
              if (
                fileUrls["prescription-file"] &&
                fileUrls["pd-measurement-photo"]
              ) {
                addToCart(); // Proceed to add the items to the cart
              }
            },
            error: function (xhr, status, error) {
              console.error("Error uploading file:", error);
            },
          });
        }
  
        // Function to add items to the cart
        function addToCart() {
          let data = {
            items: variants.map((variant) => ({
              id: variant.id,
              quantity: variant.quantity,
              properties: {
                "Prescription File": fileUrls["prescription-file"] || "",
                "PD Measurement Photo": fileUrls["pd-measurement-photo"] || "",
              },
            })),
          };
  
          // Ensure that you're passing the request data as a JSON string
          $.ajax({
            url: "/cart/add.js",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(data), // Stringify the object
            success: function (response) {
              window.location.href = "/cart"; // Redirect to the cart page after adding items
            },
            error: function (xhr, status, error) {
              console.error("Error adding variants to cart:", xhr.responseText);
            },
          });
        }
      } else if (
        $("#shopify-section-convenience-step2 .lens-box").length >= 2 ||
        $("#shopify-section-both-step3 .lens-box").length >= 2
      ) {
        let checkLens = [
          {
            prescription: false,
            nonPrescription: false,
            addon: false,
          },
          {
            prescription: false,
            nonPrescription: false,
            addon: false,
          },
        ];
  
        let productVariants = $('#step2 input[name="product_variants"]');
        let prescriptionLensTypeVariants = $(".prescription-lens-type option");
        let nonPrescriptionLensTypeVariants = $(
          ".non-prescription-readers option"
        );
        let addonsVariants = $(".lens-addons input");
        let variants = [];
  
        let lensBoxes = $(".lens-box");
  
        // Check selected variants for each lens box
        lensBoxes.each(function (index, box) {
          if (
            $(box).find(".prescription-lens-type option:checked:not([disabled])")
              .length > 0
          ) {
            checkLens[index].prescription = true;
          }
          if (
            $(box).find(
              ".non-prescription-readers option:checked:not([disabled])"
            ).length > 0
          ) {
            checkLens[index].nonPrescription = true;
          }
          if ($(box).find(".lens-addons input:checked").length > 0) {
            checkLens[index].addon = true;
          }
        });
  
        // **Ensure both boxes have at least one selection**
        let isValid = checkLens.every((obj) => Object.values(obj).includes(true));
  
        console.log("Check Lens:", checkLens);
        console.log("Is Valid:", isValid);
  
        if (isValid) {
          // Collect variants
          addonsVariants.each(function (i, v) {
            if ($(v).is(":checked") && $(v).val() != "") {
              variants.push({ id: $(v).val(), quantity: 1 });
            }
          });
  
          nonPrescriptionLensTypeVariants.each(function (i, v) {
            if ($(v).is(":checked") && $(v).val() != "") {
              variants.push({ id: $(v).val(), quantity: 1 });
            }
          });
  
          prescriptionLensTypeVariants.each(function (i, v) {
            if ($(v).is(":checked") && $(v).val() != "") {
              variants.push({ id: $(v).val(), quantity: 1 });
            }
          });
  
          productVariants.each(function (i, v) {
            if ($(this).is(":checked")) {
              variants.push({
                id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
                quantity: 1,
              });
            }
          });
  
          // Prepare the payload
          var data = {
            items: variants.map((variant) => ({
              id: variant.id,
              quantity: variant.quantity,
            })),
          };
  
          // Send AJAX request
          $.ajax({
            url: "/cart/add.js",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            success: function (response) {
              window.location.href = "/cart";
            },
            error: function (xhr, status, error) {
              console.error("Error adding variants:", xhr.responseText);
            },
          });
        } else {
          return errorModal(
            "Looks like you need more lenses!  Please choose at least two sets of lenses."
          );
        }
      } else {
        return errorModal(
          "Looks like you need more lenses!  Please choose at least two sets of lenses."
        );
      }
    }); */

    $("#step" + currentStep).removeClass("visible");
    $("#step" + (currentStep + 1)).addClass("visible");
}

// add to cart
$("#add-to-cart").on("click", function () {
    localStorage.removeItem("fetchildisvalue");
    // validation
    var fetchhasError = false;
    var fLensContainer = document.querySelectorAll('.lens-box');
    console.log("fLensContainer", fLensContainer);
    if (fLensContainer.length == 0) {
        var fLensContainer = document.querySelectorAll('.lens-form');
    }
    console.log("after If fLensContainer", fLensContainer);


    if (fLensContainer.length > 0) {
        console.log("haha length zero nahi hai.");
        $(fLensContainer).each(function (index, fcont) {
            var opticalsActive = $(fcont).find(".fil-opticals-sec-tab").hasClass("active");
            var sunsActive = $(fcont).find(".fil-suns-sec-tab").hasClass("active");

            var opticalsSelected = $(fcont).find(".prescription-lens-type").val();
            var sunsSelected = $(fcont).find(".suns-lens-type").val();

            // NEW VALIDATION FOR SUNS LENS COLOR
            var sunsLensColorSelected = $(fcont).find("input.sens-lens-color:checked").val();

            // if both tabs are inactive
            if (!opticalsActive && !sunsActive) {
                console.log("dono tab active nahi hein.");
                errorModal(
                    "Looks like you need more lenses!  Please choose at least two sets of lenses."
                );
                fetchhasError = true;
            }

            // if optical tab is active but no fields are selected. 
            if (opticalsActive && !opticalsSelected) {
                console.log("optical active hai lekin optical selected nahi hai");
                errorModal(
                    "Looks like you need more lenses!  Please choose at least two sets of lenses."
                );
                fetchhasError = true;
            }

            // if suns tab is active but no fields are selected. 
            if (sunsActive && !sunsSelected) {
                console.log("suns active hai lekin suns selected nahi hai");
                errorModal(
                    "Looks like you need more lenses!  Please choose at least two sets of lenses."
                );
                fetchhasError = true;
            }

            // NEW: if suns tab is active and suns lens is selected but no color is selected
            if (sunsActive && sunsSelected && !sunsLensColorSelected) {
                console.log("suns active hai, lens selected hai but color selected nahi hai");
                errorModal(
                    "Please select a lens color for your sun lenses."
                );
                fetchhasError = true;
            }

        });
    } console.log("fetchhasError", fetchhasError);

    if (fetchhasError == true) {
        console.log("fetchhasError true hai");
        return false;
    }
    // validation end

    updateDiscountCoupen().then((code) => {
        console.log("code!!!!!!!!!!", code);
        console.log("code...............................", code);

        if ($("#shopify-section-versatility-step1").length) {
            console.log("versatility step 1");
            let variants = [];
            // Getting product Variants from step2
            let productVariants = $('#step2 input[name="product_variants"]');

            // Getting Presciption List.

            // List of variants to add
            productVariants.each(function (i, v) {
                if ($(this).is(":checked")) {
                    variants.push({
                        id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
                        quantity: 1,
                    });
                }
            });

            fetchPrescriptionPriceList.forEach(function (item) {
                if (item.dataPrice != 0) {
                    variants.push({
                        id: item.id,
                        quantity: item.quantity
                    });
                }
            });

            // Prepare the payload with custom properties (such as prescription file URL)
            var data = {
                items: variants.map((variant, index) => {
                    // yahan par conditional wise ayegi

                    let properties = {}; // Initialize an empty object
                    // adding this attribute in order to specify which product is coming from the fetch il flow.
                    properties["fetch_discount"] = selectedDiscounts[index];

                    // prescription file url 
                    // if (prescriptionFileUrl != "") {
                    //     properties["Prescription File"] = prescriptionFileUrl;
                    // }

                    // if (pdMeasurementFileUrl != "") {
                    //     properties["PD Measurement Photo"] = pdMeasurementFileUrl;
                    // }
                    // variants.push({
                    //       id: item.id,
                    //       quantity: item.quantity
                    //     });

                    fetchPrescriptionPriceList.forEach(function (item) {
                        if (item.dataPrice == 0) {
                            console.log('yes');
                            // if Suns lens color.
                            if (item.value == 'grey' || item.value == 'brown' || item.value == 'green') {
                                // if suns lens type
                                if (variant.id == 46775917510885 || variant.id == 46775917543653 || variant.id == 46775917576421) {
                                    properties['Sun Lens Color'] = item.value;
                                }
                            }
                        }
                    });

                    return {
                        id: variant.id,
                        quantity: variant.quantity,
                        properties: properties, // Only add properties if they exist
                    };
                }),
            };

            // Send a single request to add all variants to the cart
            $.ajax({
                url: "/cart/add.js",
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify(data),
                success: function (response) {
                    // console.log("Variants added:", response);

                    // window.location.href = `/discount/${code}?redirect_to=cart`;
                    // Set a flag in localStorage
                    localStorage.setItem("redirectToCart", "true");

                    // Redirect to discount URL
                    window.location.href = `/discount/${code}?redirect_to=cart`;
                    // window.location.href = "/cart";
                    return;
                },
                error: function (xhr, status, error) {
                    console.error("Error adding variants:1", xhr.responseText);
                    console.error("Error adding variants:2", xhr.responseJSON);

                    // Extract the error message
                    let errorMessage = "Failed to add product to cart";
                    if (xhr.responseJSON && xhr.responseJSON.description) {
                        console.error("Error message:", errorMessage);
                        errorMessage = xhr.responseJSON.description;
                    } else if (xhr.responseJSON && xhr.responseJSON.message) {
                        console.error("Error message:", errorMessage);
                        errorMessage = xhr.responseJSON.message;
                    } else if (xhr.responseText) {
                        // Parse the response text to get the JSON
                        const response = JSON.parse(xhr.responseText);
                        console.error("Response text:", response);
                        console.error("Response text message:", response.message);
                        errorMessage = response.message;
                    }

                    // Show error in modal
                    errorModal(errorMessage);
                },
            });
        } else if (
            $("#shopify-section-convenience-step2 .lens-box").length >= 2
        ) {
            console.log("convenience step 2");
            // Collect all prescription file URLs
            let prescriptionFileUrls = $(".prescription-file")
                .map(function () {
                    return this.files[0]
                        ? $(this).parent().find("img").attr("src")
                        : null;
                })
                .get()
                .filter((url) => url !== null);

            // Collect all PD measurement file URLs
            let pdMeasurementFileUrls = $(".pd-measurement-photo")
                .map(function () {
                    return this.files[0]
                        ? $(this).parent().find("img").attr("src")
                        : null;
                })
                .get()
                .filter((url) => url !== null);

            let checkLens = [
                {
                    prescription: false,
                    nonPrescription: false,
                    addon: false,
                },
                {
                    prescription: false,
                    nonPrescription: false,
                    addon: false,
                },
            ];

            let productVariants = $('#step2 input[name="product_variants"]');
            let prescriptionLensTypeVariants = $(".prescription-lens-type option");
            let nonPrescriptionLensTypeVariants = $(
                ".non-prescription-readers option"
            );
            let addonsVariants = $(".lens-addons input");
            let variants = [];

            let lensBoxes = $(".lens-box");

            // Check selected variants for each lens box
            lensBoxes.each(function (index, box) {

                if (!checkLens[index]) {
                    checkLens.push({
                        prescription: false,
                        nonPrescription: false,
                        addon: false,
                    });
                }

                if (
                    $(box).find(".prescription-lens-type option:checked:not([disabled])")
                        .length > 0
                ) {
                    console.log("index", index);
                    console.log("checkLens", checkLens);
                    console.log("checkLens[index]", checkLens[index]);
                    checkLens[index].prescription = true;
                }
                if (
                    $(box).find(
                        ".non-prescription-readers option:checked:not([disabled])"
                    ).length > 0
                ) {
                    checkLens[index].nonPrescription = true;
                }
                if ($(box).find(".lens-addons input:checked").length > 0) {
                    checkLens[index].addon = true;
                }
            });

            // Ensure both boxes have at least one selection
            // let isValid = checkLens.every((obj) => Object.values(obj).includes(true));
            let isValid = fetchhasError == false ? true : false;

            console.log("Check Lens:", checkLens);
            console.log("Is Valid:", isValid);

            if (isValid) {
                // Collect variants (Add-ons and Lens types)
                // addonsVariants.each(function (i, v) {
                //   if ($(v).is(":checked") && $(v).val() != "") {
                //     variants.push({ id: $(v).val(), quantity: 1 });
                //   }
                // });

                // nonPrescriptionLensTypeVariants.each(function (i, v) {
                //   if ($(v).is(":checked") && $(v).val() != "") {
                //     variants.push({ id: $(v).val(), quantity: 1 });
                //   }
                // });

                // prescriptionLensTypeVariants.each(function (i, v) {
                //   if ($(v).is(":checked") && $(v).val() != "") {
                //     variants.push({ id: $(v).val(), quantity: 1 });
                //   }
                // });

                productVariants.each(function (i, v) {
                    if ($(this).is(":checked")) {
                        let properties = {};

                        // $(".prescription-file").each(function (i, v) {
                        //   addProperty(
                        //     properties,
                        //     `Prescription File ${++i}`,
                        //     $(v).parent().find(".img-view img").attr("src")
                        //   );
                        // });

                        // $(".pd-measurement-photo").each(function (i, v) {
                        //   addProperty(
                        //     properties,
                        //     `PD Measurement Photo ${++i}`,
                        //     $(v).parent().find(".img-view img").attr("src")
                        //   );
                        // });
                        fetchPrescriptionPriceList.forEach(function (item) {
                            if (item.dataPrice == 0) {
                                console.log('yes');
                                // if Suns lens color.
                                if (item.value == 'grey' || item.value == 'brown' || item.value == 'green') {
                                    console.log('item grey hai daal do andar');
                                    // if suns lens type then suns lens color into it. 
                                    // if (productVariants[i].id == 46775917510885 || productVariants[i].id == 46775917543653 || productVariants[i].id == 46775917576421) {         
                                    //   console.log('isme bhi agya hai bhai');
                                    properties['Sun Lens Color'] = item.value;
                                    // }
                                }
                            }
                        });

                        addProperty(properties, 'fetch_discount', selectedDiscounts[i]);

                        variants.push({
                            id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
                            quantity: 1,
                            properties: properties,
                        });
                    }
                });

                // List of variants to add
                // productVariants.each(function (i, v) {
                //     if ($(this).is(":checked")) {
                //         variants.push({
                //             id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
                //             quantity: 1,
                //         });
                //     }
                // });

                fetchPrescriptionPriceList.forEach(function (item) {
                    if (item.dataPrice != 0) {
                        variants.push({
                            id: item.id,
                            quantity: item.quantity
                        });
                    }
                });

                // Prepare the payload
                var data = {
                    items: variants,
                };
                var fetchildisid = localStorage.getItem("fetchildisid");

                // Send AJAX request
                $.ajax({
                    url: "/cart/add.js",
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                    success: function (response) {
                        if (!fetchildisid) {
                            console.log("fetchildisid if.............", fetchildisid);
                            // window.location.href = `/discount/${fetchildisid}?redirect_to=cart`;

                            // Set a flag in localStorage
                            localStorage.setItem("redirectToCart", "true");

                            // Redirect to discount URL
                            window.location.href = `/discount/${fetchildisid}?redirect_to=cart`;
                        } else {
                            console.log("fetchildisid else.............", fetchildisid);
                            window.location.href = "/cart";
                        }
                        return;
                    },
                    error: function (xhr, status, error) {
                        console.error("Error adding variants:1", xhr.responseText);
                        // Extract the error message
                        let errorMessage = "Failed to add product to cart";
                        if (xhr.responseJSON && xhr.responseJSON.description) {
                            console.error("Error message:", errorMessage);
                            errorMessage = xhr.responseJSON.description;
                        } else if (xhr.responseJSON && xhr.responseJSON.message) {
                            console.error("Error message:", errorMessage);
                            errorMessage = xhr.responseJSON.message;
                        } else if (xhr.responseText) {
                            // Parse the response text to get the JSON
                            const response = JSON.parse(xhr.responseText);
                            console.error("Response text:", response);
                            console.error("Response text message:", response.message);
                            errorMessage = response.message;
                        }

                        // Show error in modal
                        errorModal(errorMessage);
                    },
                });
            } else {
                return errorModal(
                    "Looks like you need more lenses!  Please choose at least two sets of lenses."
                );
            }
        } else if ($("#shopify-section-both-step3 .lens-box").length >= 2) {
            console.log("both step 3");
            // Collect all prescription file URLs
            let prescriptionFileUrls = $(".prescription-file")
                .map(function () {
                    return this.files[0]
                        ? $(this).parent().find("img").attr("src")
                        : null;
                })
                .get()
                .filter((url) => url !== null);

            // Collect all PD measurement file URLs
            let pdMeasurementFileUrls = $(".pd-measurement-photo")
                .map(function () {
                    return this.files[0]
                        ? $(this).parent().find("img").attr("src")
                        : null;
                })
                .get()
                .filter((url) => url !== null);

            let checkLens = [
                {
                    prescription: false,
                    nonPrescription: false,
                    addon: false,
                },
                {
                    prescription: false,
                    nonPrescription: false,
                    addon: false,
                },
            ];

            let productVariants = $('#step2 input[name="product_variants"]');
            let prescriptionLensTypeVariants = $(".prescription-lens-type option");
            let nonPrescriptionLensTypeVariants = $(
                ".non-prescription-readers option"
            );
            let addonsVariants = $(".lens-addons input");
            let variants = [];

            let lensBoxes = $(".lens-box");

            // Check selected variants for each lens box
            lensBoxes.each(function (index, box) {

                if (!checkLens[index]) {
                    checkLens.push({
                        prescription: false,
                        nonPrescription: false,
                        addon: false,
                    });
                }

                if (
                    $(box).find(".prescription-lens-type option:checked:not([disabled])")
                        .length > 0
                ) {
                    checkLens[index].prescription = true;
                }
                if (
                    $(box).find(
                        ".non-prescription-readers option:checked:not([disabled])"
                    ).length > 0
                ) {
                    checkLens[index].nonPrescription = true;
                }
                if ($(box).find(".lens-addons input:checked").length > 0) {
                    checkLens[index].addon = true;
                }
            });

            // Ensure both boxes have at least one selection
            // let isValid = checkLens.every((obj) => Object.values(obj).includes(true));
            let isValid = fetchhasError == false ? true : false;

            console.log("Check Lens:", checkLens);
            console.log("Is Valid:", isValid);

            if (isValid) {
                // Collect variants (Add-ons and Lens types)
                // addonsVariants.each(function (i, v) {
                //   if ($(v).is(":checked") && $(v).val() != "") {
                //     variants.push({ id: $(v).val(), quantity: 1 });
                //   }
                // });

                // nonPrescriptionLensTypeVariants.each(function (i, v) {
                //   if ($(v).is(":checked") && $(v).val() != "") {
                //     variants.push({ id: $(v).val(), quantity: 1 });
                //   }
                // });

                // prescriptionLensTypeVariants.each(function (i, v) {
                //   if ($(v).is(":checked") && $(v).val() != "") {
                //     variants.push({ id: $(v).val(), quantity: 1 });
                //   }
                // });
                let step3index = 0
                productVariants.each(function (i, v) {
                    console.log("step3index", step3index);
                    if ($(this).is(":checked")) {
                        let properties = {};

                        // $(".prescription-file").each(function (i, v) {
                        //   addProperty(
                        //     properties,
                        //     `Prescription File ${++i}`,
                        //     $(v).parent().find(".img-view img").attr("src")
                        //   );
                        // });

                        // $(".pd-measurement-photo").each(function (i, v) {
                        //   addProperty(
                        //     properties,
                        //     `PD Measurement Photo ${++i}`,
                        //     $(v).parent().find(".img-view img").attr("src")
                        //   );
                        // });
                        fetchPrescriptionPriceList.forEach(function (item) {
                            if (item.dataPrice == 0) {
                                console.log('yes');
                                // if Suns lens color.
                                if (item.value == 'grey' || item.value == 'brown' || item.value == 'green') {
                                    console.log('item grey hai daal do andar');
                                    // if suns lens type then suns lens color into it. 
                                    // if (productVariants[i].id == 46775917510885 || productVariants[i].id == 46775917543653 || productVariants[i].id == 46775917576421) {         
                                    //   console.log('isme bhi agya hai bhai');
                                    properties['Sun Lens Color'] = item.value;
                                    // }
                                }
                            }
                        });

                        addProperty(properties, 'fetch_discount', selectedDiscounts[step3index]);

                        variants.push({
                            id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
                            quantity: 1,
                            properties: properties,
                        });
                        step3index++;
                    }
                });

                // List of variants to add
                // productVariants.each(function (i, v) {
                //     if ($(this).is(":checked")) {
                //         variants.push({
                //             id: $(this).val().replace("gid://shopify/ProductVariant/", ""),
                //             quantity: 1,
                //         });
                //     }
                // });

                fetchPrescriptionPriceList.forEach(function (item) {
                    if (item.dataPrice != 0) {
                        variants.push({
                            id: item.id,
                            quantity: item.quantity
                        });
                    }
                });

                // Prepare the payload
                var data = {
                    items: variants,
                };

                // Send AJAX request
                $.ajax({
                    url: "/cart/add.js",
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                    success: function (response) {
                        // window.location.href = `/discount/${code}?redirect_to=cart`;

                        // Set a flag in localStorage
                        localStorage.setItem("redirectToCart", "true");

                        // Redirect to discount URL
                        window.location.href = `/discount/${code}?redirect_to=cart`;
                        // window.location.href = "/cart";
                        return;
                    },
                    error: function (xhr, status, error) {
                        console.error("Error adding variants:1", xhr.responseText);
                        // Extract the error message
                        let errorMessage = "Failed to add product to cart";
                        if (xhr.responseJSON && xhr.responseJSON.description) {
                            console.error("Error message:", errorMessage);
                            errorMessage = xhr.responseJSON.description;
                        } else if (xhr.responseJSON && xhr.responseJSON.message) {
                            console.error("Error message:", errorMessage);
                            errorMessage = xhr.responseJSON.message;
                        } else if (xhr.responseText) {
                            // Parse the response text to get the JSON
                            const response = JSON.parse(xhr.responseText);
                            console.error("Response text:", response);
                            console.error("Response text message:", response.message);
                            errorMessage = response.message;
                        }

                        // Show error in modal
                        errorModal(errorMessage);
                    },
                });
            } else {
                return errorModal(
                    "Looks like you need more lenses!  Please choose at least two sets of lenses."
                );
            }
        }
        else {
            console.log("else wala");
            return errorModal(
                "Looks like you need more lenses!  Please choose at least two sets of lenses."
            );
        }
    });
});
// add to cart end

// Previous step function
function prevStep(currentStep) {
    // console.log("Prev Step: " + currentStep);
    $("#step" + currentStep).removeClass("visible");
    $("#step" + (currentStep - 1)).addClass("visible");
}

// Update discount code price
async function updateDiscountCoupen(discountId = '1420174229806') {
    console.log("Update Discount Coupen Function Called");
    if (!discountId) {
        console.error("Error: Discount ID is required!");
        return;
    }

    // Ensure selectedDiscounts is an array and contains valid numbers
    if (!Array.isArray(selectedDiscounts) || selectedDiscounts.length === 0) {
        console.error("Error: selectedDiscounts must be a non-empty array.");
        return;
    }

    // Calculate final discounted amount
    const finalDiscountedAmount = selectedDiscounts.reduce((sum, num) => sum + (Number(num) || 0), 0);

    if (isNaN(finalDiscountedAmount) || finalDiscountedAmount <= 0) {
        console.error("Error: Invalid final discount amount:", finalDiscountedAmount);
        return;
    }
    console.log("Final Discount Amount:", finalDiscountedAmount);

    // checking if the discount is already exists
    console.log("Checking if discount already exists...");
    var fetchildisid = localStorage.getItem("fetchildisid");
    console.log("fetchildisid!!!!!", fetchildisid);
    if (fetchildisid) {
        console.log("fetchildisid exists. checking the discount code...");

        try {
            const encodedId = encodeURIComponent(fetchildisid);
            console.log(`Getting discount code...${API_BASE_URL}/discount/${encodedId}`);
            // Make API Request
            const response = await fetch(`${API_BASE_URL}/discount/${encodedId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            console.log("Response:", response);

            const result = await response.json();

            console.log('Discount Got successfully:', result);
            console.log("result error", result.errors);


            // if existing discount found and no error found.
            if (result.success === true) {
                // Update Discount start
                console.log("Get Order Discount Response:", result.data.id);

                var getPricetoUpdated = result.data.amount;
                getPricetoUpdated = parseFloat(finalDiscountedAmount) + parseFloat(getPricetoUpdated);

                console.log('the updated discount amount to be updated:', getPricetoUpdated);

                // updating the discount since it is exists already.
                console.log("Discount Already exists. updating the disount code...");
                var sessionDisCode = localStorage.getItem("fetchildiscode");

                try {
                    // Make API Request
                    console.log(`Creating new discount code...${API_BASE_URL}/discount/update`);
                    // Make API Request
                    const response = await fetch(`${API_BASE_URL}/discount/update`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest" // Add this header
                        },
                        body: JSON.stringify({
                            discountId: fetchildisid,
                            discounCode: sessionDisCode,
                            newAmount: getPricetoUpdated
                        }),
                    });
                    console.log("Response:", response);

                    const updateresult = await response.json();

                    console.log("Updated Order Discount Response:", updateresult);

                    return sessionDisCode;
                } catch (error) {
                    console.error("Unexpected Error while updating the Discount Code:", error);
                    return false;
                }
                // Update Discount end
            }
            return;
        } catch (error) {
            console.error("Unexpected Get discount Error:getresult", error);
            return false;
        }
    }
    // return;
    console.log("Discount does not exist. Creating a new discount code...");
    // creating the new discount.
    var epochMilliseconds = Date.now();
    var codeTitleAndCode = 'fetch-' + epochMilliseconds;

    console.log("Discount does not exist. Creating a new discount code...");
    console.log("Final Discounted Amount:", finalDiscountedAmount);
    console.log("codeTitleAndCode:", codeTitleAndCode);

    try {
        console.log(`Creating new discount code...${API_BASE_URL}/discount/create`);
        // Make API Request
        const response = await fetch(`${API_BASE_URL}/discount/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                titleandcode: codeTitleAndCode,
                amount: finalDiscountedAmount
            }),
        });
        console.log("Response:", response);

        const result = await response.json();

        console.log('Discount created successfully:', result);

        localStorage.setItem("fetchildiscode", codeTitleAndCode);
        localStorage.setItem("fetchildisid", result.data.discountId);
        return codeTitleAndCode;
    } catch (error) {
        console.error("Unexpected Error:", error);
        return false;
    }
}

// Fetch product data function
async function fetchProductById(productId) {
    console.log("Fetching product data for ID:", productId);
    const query = `
    {
        product(id: "${productId}") {
            id
            title
            description
            createdAt
            updatedAt
            variants(first: 250) {
                edges {
                    node {
                        id
                        title
                        price {
                            amount
                            currencyCode
                        }
                        sku
                        availableForSale
                        image {
                            src
                            altText
                        }
                    }
                }
            }
            images(first: 5) {
                edges {
                    node {
                        src
                        altText
                    }
                }
            }
        }
    }`;
    console.log("GraphQL Query:", query);
    try {
        const response = await fetch(
            `https://${SHOPIFY_DOMAIN}/api/2023-01/graphql.json`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": STORE_FRONT_ACCESS_TOKEN,
                },
                body: JSON.stringify({ query }),
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Product Data:", data);
        return data.data.product;
    } catch (error) {
        console.error("Error fetching product:", error);
        return null;
    }
}

// Discount functionality
function discountFunctionality() {
    console.log('running discount functionality');
    selectedDiscounts = new Array(document.querySelector('#step2').querySelectorAll('.color-options').length - 1).fill(0); // Initialize array with 0s
    console.log('selectedDiscounts', selectedDiscounts);

    document.querySelectorAll('input[name="product_variants"]').forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            updateDiscountArray(selectedDiscounts);
            applyDiscounts(selectedDiscounts);
        });
    });
}

// Step 1: Update the discount array
function updateDiscountArray(selectedDiscounts) {
    // Reset the array before recalculating discounts
    selectedDiscounts.fill(0);

    let checkedVariants = Array.from(document.querySelector('#step2').querySelectorAll('.color-options'));

    checkedVariants.forEach((variant, index) => {
        if (index == 0) {
            selectedDiscounts[0] = 0;
        } else {
            selectedDiscounts[index] = index == 1 ? 25 : 50; // First selected gets 25, others get 50
        }
    });

    console.log("Updated Discounts Array:", selectedDiscounts);
}

// Step 2: Apply the discounts
function applyDiscounts(selectedDiscounts, step = 'step2') {
    console.log('Discount Applying.,.,.,.');
    var stepid = '#' + step;
    if (step == 'step3' && selectedDiscounts.length == 0) {
        return;
    }
    document.querySelector(stepid).querySelectorAll('.color-options').forEach((element, index) => {
        let priceElement = element.querySelector('.c-price'); // Find .c-price inside .color-options
        if (priceElement) {
            console.log('agya');
            console.log('selected discounts', selectedDiscounts);
            let originalPrice = parseFloat(priceElement.textContent.replace('$', '').trim()); // Remove $ and convert to number
            let newPrice = Math.max(originalPrice - selectedDiscounts[index], 0); // Apply discount


            priceElement.classList.add('cutted');

            let discountedPriceElement = element.querySelector('.c-price.discounted');

            if (discountedPriceElement) {
                // If exists, update the price
                discountedPriceElement.textContent = `$${newPrice.toFixed(2)}`;
            } else {
                // If not exists, create and append the element
                discountedPriceElement = document.createElement('span');
                discountedPriceElement.classList.add('c-price', 'discounted');
                discountedPriceElement.textContent = `$${newPrice.toFixed(2)}`;

                priceElement.insertAdjacentElement('afterend', discountedPriceElement);
            }
        }
    });

    // reflect total prices
    updateTotalPrice();
}

function updateTotalPrice() {
    let totalprice = 0;

    let discountedprices = document.querySelector('#step2').querySelectorAll('.c-price.discounted');

    if (discountedprices.length > 0) {
        discountedprices.forEach((discountedprice, index) => {
            totalprice += parseFloat(discountedprice.textContent.replace('$', '').trim());
        });
    } else {
        discountedprices = document.querySelector('#step3').querySelectorAll('.c-price');

        if (discountedprices) {
            discountedprices.forEach((discountedprice, index) => {
                totalprice += parseFloat(discountedprice.textContent.replace('$', '').trim());
            });
        }
    }

    // Add prices from fetchPrescriptionPriceList
    if (Array.isArray(fetchPrescriptionPriceList) && fetchPrescriptionPriceList.length > 0) {
        fetchPrescriptionPriceList.forEach((item) => {
            totalprice += parseFloat(item.dataPrice) * (item.quantity || 1);
        });
    }

    var totalpricesel = document.querySelectorAll('.total-price');

    if (totalpricesel) {
        totalpricesel.forEach((el, index) => {
            el.textContent = `$${totalprice.toFixed(2)}`;
        });
    }
}

// Error Modal
// const errorModal = (title) => {
//   Swal.fire({
//     title: title,
//     icon: "error",
//     confirmButtonColor: "#000000",
//   });
//   return false;
// };

const errorModal = (title) => {
    Swal.fire({
        title: title,
        icon: "error",
        confirmButtonColor: "#000000",
        background: "#ffffff",
        backdrop: "rgba(0,0,0,0.5)",
        allowOutsideClick: false,
        customClass: {
            popup: 'custom-swal-popup',
            title: 'custom-swal-title',
        },
    });
    return false;
};

const addProperty = (obj, key, value) => {
    obj[key] = value;
};


// stepform3 js
// optical tab on click
$(document).on('click', '.fil-opticals-sec-tab', function () {
    if (!$(this).hasClass('active')) {
        var maincontainer = $(this).closest(".lens-box.active");

        if (maincontainer.length == 0) {
            var maincontainer = $(this).closest(".lens-form");
        }

        $(maincontainer).find('.optical-lens-sec').css('display', 'block');
        $(maincontainer).find('.optical-lens-sec').removeClass('fil-d-none');
        $(maincontainer).find('.suns-lens-sec').css('display', 'none');
        $(maincontainer).find('.suns-lens-sec').addClass('fil-d-none');
        $(this).addClass('active');
        $(maincontainer).find('.fil-suns-sec-tab').removeClass('active');

        var opticalLensSec = $(maincontainer).find('.fil-optical-sec');
        $(opticalLensSec).find('.prescription-lens-type').prop('selectedIndex', 0);
        $(opticalLensSec).find('.presc-file-sec').addClass('fil-d-none');
        $(opticalLensSec).find('.pup-dis-file-sec').addClass('fil-d-none');
        $(opticalLensSec).find('.non-presc-readers-sec').addClass('fil-d-none');
        $(opticalLensSec).find('.non-presc-readers-sec select').prop('selectedIndex', 0);
        $(opticalLensSec).find('.fil-addons-sec input[type="checkbox"]').prop('checked', false);
        $(opticalLensSec).find('.fil-addons-sec').addClass('fil-d-none');
        $(opticalLensSec).find('.selctd-vlue').text("");
    }
});

// suns tab on click
$(document).on('click', '.fil-suns-sec-tab', function () {
    if (!$(this).hasClass('active')) {
        var maincontainer = $(this).closest(".lens-box.active");

        if (maincontainer.length == 0) {
            var maincontainer = $(this).closest(".lens-form");
        }

        $(maincontainer).find('.optical-lens-sec').css('display', 'none');
        $(maincontainer).find('.optical-lens-sec').addClass('fil-d-none');
        $(maincontainer).find('.suns-lens-sec').css('display', 'block');
        $(maincontainer).find('.suns-lens-sec').removeClass('fil-d-none');
        $(this).addClass('active');
        $(maincontainer).find('.fil-opticals-sec-tab').removeClass('active');

        var sunLensSec = $(maincontainer).find('.suns-lens-sec');
        $(sunLensSec).find('.suns-lens-type').prop('selectedIndex', 0);
        $(sunLensSec).find('.presc-file-sec').addClass('fil-d-none');
        $(sunLensSec).find('.pup-dis-file-sec').addClass('fil-d-none');
        $(sunLensSec).find('.suns-lens-color-sec').addClass('fil-d-none');
        $(sunLensSec).find('.custom-french-sun-lens-sec').addClass('fil-d-none');
        $(sunLensSec).find('.suns-addons-sec').addClass('fil-d-none');
        $(sunLensSec).find('.selctd-vlue').text("");
    }
});

// optical lens prescription
$(document).on("change", ".prescription-lens-type", function () {
    let _this = $(this);
    var selectedOption = $(_this).find("option:selected").text();
    var maincontainer = $(_this).closest(".lens-box.active");

    // Remove the text inside parentheses along with the parentheses
    var cleanedText = selectedOption.replace(/\s*\(.*?\)\s*/g, "").trim();

    // Update the small tag with cleaned text
    $(_this).closest(".form-group").find(".selctd-vlue").text(cleanedText);

    if (maincontainer.length == 0) {
        var maincontainer = $(_this).closest(".lens-form");
    }

    // show non presc
    if ($(_this).val() == '46775821730021') {
        // if non prescription
        $(maincontainer).find('.non-presc-readers-sec').removeClass('fil-d-none');

        $(maincontainer).find('.presc-file-sec').addClass('fil-d-none');
        $(maincontainer).find('.pup-dis-file-sec').addClass('fil-d-none');
        $(maincontainer).find('.fil-addons-sec').addClass('fil-d-none');
        $(maincontainer).find('.fil-addons-sec input[type="checkbox"]').prop('checkbox', false);
        $(maincontainer).find('#46775869014245').removeClass('fil-d-none');
        $(maincontainer).find('#46775869047013').removeClass('fil-d-none');
        $(maincontainer).find('#46775869112549').addClass('fil-d-none');
        $(maincontainer).find('#46775869112549 input[type="checkbox"]').prop('checked', false);

    } else if ($(_this).val() == '46775821762789') {
        // if non prescription blue blockers
        $(maincontainer).find('.non-prescription-readers').prop("selectedIndex", 0);
        $(maincontainer).find('.non-presc-readers-sec').addClass('fil-d-none');
        $(maincontainer).find('.presc-file-sec').addClass('fil-d-none');
        $(maincontainer).find('.pup-dis-file-sec').addClass('fil-d-none');
        $(maincontainer).find('#46775869014245').addClass('fil-d-none');
        $(maincontainer).find('#46775869047013').addClass('fil-d-none');

        $(maincontainer).find('.fil-addons-sec').removeClass('fil-d-none');
        $(maincontainer).find('#46775869112549').removeClass('fil-d-none');

    } else {
        // if progressive or single
        $(maincontainer).find('.non-prescription-readers').prop("selectedIndex", 0);
        $(maincontainer).find('.non-presc-readers-sec').addClass('fil-d-none');
        $(maincontainer).find('.presc-file-sec').removeClass('fil-d-none');
        $(maincontainer).find('.pup-dis-file-sec').removeClass('fil-d-none');
        $(maincontainer).find('.fil-addons-sec').removeClass('fil-d-none');
        $(maincontainer).find('#46775869112549').addClass('fil-d-none');
        $(maincontainer).find('#46775869112549 input[type="checkbox"]').prop('checked', false);

        $(maincontainer).find('#46775869014245').removeClass('fil-d-none');
        $(maincontainer).find('#46775869047013').removeClass('fil-d-none');
    }
});

// optical lens addons checkboxes
$(document).on("change", ".lens-addons input[type='checkbox']", function () {
    var selectedAddons = [];

    $(this).closest('.form-group').find("input[type='checkbox']:checked").each(function () {
        var labelText = $(this).closest("label").text().trim();
        var cleanedText = labelText.replace(/\s*\(.*?\)\s*/g, "").trim();
        selectedAddons.push(cleanedText);
    });

    // Update the small tag with selected addon names
    $(".fil-addons-sec .selctd-vlue").text(selectedAddons.join(", "));
});

// Optical Non Prescription field.
$(document).on("change", ".non-prescription-readers", function () {
    let _this = $(this);

    var selectedOption = $(_this).find("option:selected").text();

    // Remove the text inside parentheses along with the parentheses
    var cleanedText = selectedOption.replace(/\s*\(.*?\)\s*/g, "").trim();

    // Update the small tag with cleaned text
    $(_this).closest(".form-group").find(".selctd-vlue").text(cleanedText);
});

// optical lens prescription
$(document).on("change", ".suns-lens-type", function () {
    let _this = $(this);
    var selectedOption = $(_this).find("option:selected").text();

    // Remove the text inside parentheses along with the parentheses
    var cleanedText = selectedOption.replace(/\s*\(.*?\)\s*/g, "").trim();

    // Update the small tag with cleaned text
    $(_this).closest(".form-group").find(".selctd-vlue").text(cleanedText);

    var maincontainer = $(_this).closest(".lens-box.active");
    if (maincontainer.length == 0) {
        var maincontainer = $(_this).closest(".lens-form");
    }

    if ($(_this).val() == '46775917510885') {
        // if single polarized
        $(maincontainer).find('.presc-file-sec').removeClass('fil-d-none');
        $(maincontainer).find('.pup-dis-file-sec').removeClass('fil-d-none');
        $(maincontainer).find('.suns-addons-sec').removeClass('fil-d-none');
        // $(maincontainer).find('.suns-lens-color').removeClass('fil-d-none');
        $(maincontainer).find('.suns-lens-color-sec').removeClass('fil-d-none');

        $(maincontainer).find('.suns-addons-sec').find('.46775869079781').addClass('fil-d-none');
        $(maincontainer).find('.suns-addons-sec').find('.46775869112549').addClass('fil-d-none');
        $(maincontainer).find('.custom-french-lenses').addClass('fil-d-none');
        $(maincontainer).find('.custom-french-sun-lens-sec').addClass('fil-d-none');

    } else if ($(_this).val() == '46775917543653') {
        // progressive polarized
        $(maincontainer).find('.presc-file-sec').removeClass('fil-d-none');
        $(maincontainer).find('.pup-dis-file-sec').removeClass('fil-d-none');
        $(maincontainer).find('.suns-addons-sec').removeClass('fil-d-none');
        // $(maincontainer).find('.suns-lens-color').removeClass('fil-d-none');
        $(maincontainer).find('.suns-lens-color-sec').removeClass('fil-d-none');

        $(maincontainer).find('.suns-addons-sec').find('.46775869079781').addClass('fil-d-none');
        $(maincontainer).find('.suns-addons-sec').find('.46775869112549').addClass('fil-d-none');
        $(maincontainer).find('.custom-french-lenses').addClass('fil-d-none');
        $(maincontainer).find('.custom-french-sun-lens-sec').addClass('fil-d-none');

    } else if ($(_this).val() == '46775917576421') {
        // non prescription polarized
        $(maincontainer).find('.presc-file-sec').addClass('fil-d-none');
        $(maincontainer).find('.pup-dis-file-sec').addClass('fil-d-none');
        $(maincontainer).find('.suns-addons-sec').addClass('fil-d-none');

        // $(maincontainer).find('.suns-lens-color').removeClass('fil-d-none');
        $(maincontainer).find('.suns-lens-color-sec').removeClass('fil-d-none');
        $(maincontainer).find('.suns-addons-sec').find('input[type="checkbox"]').prop("checked", false);

        $(maincontainer).find('.custom-french-lenses').removeClass('fil-d-none');

        if ($(maincontainer).find('.custom-french-lenses .sens-lens-color').is(':checked')) {
            $(maincontainer).find('.custom-french-sun-lens-sec').removeClass('fil-d-none');
        }
    }
});

// suns lens addons checkboxes
$(document).on("change", ".suns-addons-sec input[type='checkbox']", function () {
    var selectedAddons = [];

    $(".lens-addons input[type='checkbox']:checked").each(function () {
        var labelText = $(this).closest("label").text().trim();
        var cleanedText = labelText.replace(/\s*\(.*?\)\s*/g, "").trim();
        selectedAddons.push(cleanedText);
    });

    // Update the small tag with selected addon names
    $(".suns-addons-sec .selctd-vlue").text(selectedAddons.join(", "));
});

// custom-french-sun-lens
$(document).on("change", ".custom-french-sun-lens", function () {
    var selectedOption = $(this).find("option:selected").text();
    var cleanedText = selectedOption.replace(/\s*\(.*?\)\s*/g, "").trim();

    // Update the small tag with cleaned text
    $(this).closest(".form-group").find(".selctd-vlue").text(cleanedText);
});

// File upload event.

// File upload event end.

// on frech lend radio checked.
$(document).on('click', '.sens-lens-color', function () {
    if ($(this).val() == 'custom-french-lenses') {
        $('.custom-french-sun-lens-sec').removeClass('fil-d-none');
    } else {
        $('.custom-french-sun-lens-sec').addClass('fil-d-none');
    }
});

// Update Prescription List on Step3

function updatePrescriptionList() {
    fetchPrescriptionPriceList = []; // Reset the array

    let lensBoxes = document.querySelectorAll(".lens-box"); // Get all lens boxes
    let formContainer = document.querySelector(".lens-form");

    function processSelections(container, boxIndex = null) {
        let activeTab = container.querySelector(".fil-sec-tab.active"); // Get active tab inside lens-box

        // Skip if no active tab exists
        if (!activeTab) {
            return;
        }

        var activecontainer = null;

        // if any active tab then get that active tab.
        if ($(activeTab).hasClass("fil-opticals-sec-tab")) {
            activecontainer = container.querySelector(".optical-lens-sec");
        } else if ($(activeTab).hasClass("fil-suns-sec-tab")) {
            activecontainer = container.querySelector(".suns-lens-sec");
        }

        // if no active lens then return    
        if (activecontainer == null) {
            return;
        }

        let selectedElements = [
            ...activecontainer.querySelectorAll("select"),
            ...activecontainer.querySelectorAll("input[type='checkbox']:checked"),
            ...activecontainer.querySelectorAll("input[type='radio']:checked")
        ];

        selectedElements.forEach((el) => {
            let value = el.value;
            let dataPrice = (el.tagName === "SELECT" ? el.options[el.selectedIndex].dataset.price : el.dataset.price) || "0";
            let optionText = el.tagName === "SELECT" ? el.options[el.selectedIndex].text : el.parentNode.innerText.trim();
            optionText = optionText.replace(/\s*\(.*?\)\s*/g, "").trim();
            let dataId = el.dataset.id || el.value;

            if (value) {
                let existingItem = fetchPrescriptionPriceList.find(item => item.value === value);
                if (existingItem) {
                    existingItem.quantity += 1;
                } else {
                    fetchPrescriptionPriceList.push({
                        boxIndex: boxIndex, // Track which lens-box this belongs to
                        value: value,
                        dataPrice: dataPrice,
                        optionText: optionText,
                        id: dataId,
                        quantity: 1
                    });
                }
            }
        });
    }

    // If no active lens-box exists, process the lens-form (single selection)
    if (lensBoxes.length === 0) {
        processSelections(formContainer, null);
    } else {
        // Process all active lens-box elements
        lensBoxes.forEach((box, index) => {
            processSelections(box, index);
        });
    }

    console.log(fetchPrescriptionPriceList);
}

function displaySelectedItems() {
    console.log("displaySelectedItems...........");
    let lensList = document.querySelector("#step3 ul.lens-list");
    let lensList2 = document.querySelector("#step2 ul.lens-list");
    console.log("lensList", lensList);
    console.log("lensList.length", lensList.length);
    console.log("lensList2", lensList2);
    console.log("lensList2.length", lensList2.length);
    if (!lensList) return; // If the list element doesn't exist, do nothing
    if (!lensList2) return; // If the list element doesn't exist, do nothing

    lensList.innerHTML = ""; // Clear existing items
    lensList2.innerHTML = ""; // Clear existing items

    fetchPrescriptionPriceList.forEach((item) => {
        console.log("item11111", item);
        let listItem = document.createElement("li");
        listItem.innerHTML = `
            <div>${item.optionText} ${item.quantity > 1 ? `(${item.quantity})` : ""}</div>
            <div>${item.dataPrice != 0 ? '$' + parseFloat(item.dataPrice).toFixed(2) : ''}</div>
        `;
        lensList.appendChild(listItem);
    });

    fetchPrescriptionPriceList.forEach((item) => {
        console.log("item22222", item);
        let listItem2 = document.createElement("li");
        listItem2.innerHTML = `
            <div>${item.optionText} ${item.quantity > 1 ? `(${item.quantity})` : ""}</div>
            <div>${item.dataPrice != 0 ? '$' + parseFloat(item.dataPrice).toFixed(2) : ''}</div>
        `;
        lensList2.appendChild(listItem2);
    });
}

document.querySelector(".lens-form").addEventListener("change", function (event) {
    if (event.target.matches("select, input[type='checkbox'], input[type='radio']")) {
        setTimeout(() => {
            updatePrescriptionList();
            displaySelectedItems();
            updateTotalPrice();
        }, 200);
    }
});
// End Update Prescription List Step3



$(document).ready(function () {

    // File selection
    $(document).on("click", ".file-label", function () {
        $(this).next("input").click();
    });

    // Drag and drop functionality
    $('.file-label').each(function () {
        const $label = $(this);

        // Prevent default drag behaviors
        $label.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
        })
            .on('dragover dragenter', function () {
                $label.addClass('dragover');
            })
            .on('dragleave dragend drop', function () {
                $label.removeClass('dragover');
            })
            .on('drop', function (e) {
                const files = e.originalEvent.dataTransfer.files;
                if (files.length) {
                    $(this).next("input").prop('files', files);

                    // Trigger change event if you need to handle file selection
                    $(this).next("input").trigger('change');
                }
            });
    });

    // Optional: Display file name when selected
    $('.file-input').on('change', function () {
        const fileName = $(this).val().split('\\').pop();
        if (fileName) {
            // $(this).prev('.file-label').find('.upload-instructions').html(
            //   `<span>Selected: ${fileName}</span>`
            // );
        }
    });


    $(document).on("click", ".add-more-lenses", async function () {
        console.log("add more lenses clicked");
        let _this = $(this);
        let lens_box_parent = _this.parents().eq(3);
        let lens_btn_parent = _this.parent().parent();
        let step_count = lens_btn_parent.find(".lens-add").children().length;

        $(".lens-box").removeClass('active');
        let duplicate = $(".lens-box").first().clone();
        duplicate.addClass('active');
        duplicate.find("select").prop("selectedIndex", 0);
        duplicate.find("input[type='checkbox']").prop("checked", false);
        duplicate.find("input[type='file']").val("");
        duplicate.find(".selctd-vlue").text("");
        duplicate.find(".fil-sec-tab.active").removeClass("active");
        duplicate.find(".optical-lens-sec").addClass("fil-d-none");
        duplicate.find(".suns-lens-sec").addClass("fil-d-none");
        // Set a unique name for input.sens-lens-color
        let uniqueId = Date.now(); // or you can use step_count + 1
        duplicate.find("input.sens-lens-color").each(function (index) {
            $(this).attr("name", `sens-lens-color-${uniqueId}`);
        });

        $(".lens-box").last().after(duplicate);

        // Remove active class from previous boxes and append new one
        lens_box_parent.find(".lens-box").removeClass("active");
        $(duplicate).addClass('active');

        // Update step indicators
        lens_btn_parent.find(".lens-add span").removeClass("active");
        lens_btn_parent.find(".lens-add")
            .append(
                `<span class="active" data-lens-step="${step_count + 1}">
        <div class="close-icon">✖</div>
        ${step_count + 1
                }</span>`
            );
    });

    // Show popup when clicking specifically on the label or input
    $('.product-item.pro-popup').on('click', 'input[type="radio"], label', function (e) {
        // Get the parent product item
        var $productItem = $(this).closest('.product-item');

        // Hide all other popups first
        $('.pro-desc-popup').not($productItem.find('.pro-desc-popup')).hide();

        // Show current popup
        $productItem.find('.pro-desc-popup').show();

        // Prevent the event from bubbling to the product-item handler
        e.stopPropagation();
    });

    // Close popups when clicking anywhere else on the page
    $(document).on('click', function (e) {
        // Check if click was outside any product item and not on a popup
        if (!$(e.target).closest('.product-item.pro-popup').length &&
            !$(e.target).closest('.pro-desc-popup').length) {
            $('.pro-desc-popup').hide();
        }
    });

    // Prevent popup from closing when clicking inside it
    $('.pro-desc-popup').on('click', function (e) {
        e.stopPropagation();
    });

    // Special handler for the zoom button to prevent popup
    $('.pro-icon').on('click', function (e) {
        e.stopPropagation();
        // Your zoom functionality here
    });
});

var params = {
    apiKey: '6saWXfFWJSafCBALgo2uRv4eCDVQItfxw5y4leo1',
    frame: 'DYLCHILSUN',
    onStopVto: hide,
    onIssue: (data) => {
        console.log(data);
    },
};

window.onload = function () {
    window.fitmixInstance = FitMix.createWidget('fitmix-container-box', params, function () {
        console.log('VTO module is ready.');
        // In order to start automatically the VTO, 
        // start in this "initialization done" callback
        // Note that we recommend to initialization early in the webpage
        // and then start when the user clicks on the CTA in your page
        //openVto()
    });
}

$('div#fitmix-container').on('click', function (e) {
    hide();
    // fitmixInstance.closeVto();
    stopVto();
})

const fitmix = document.getElementById("fitmix-container-box")

function hide() {
    fitmix.style.display = 'none';
    $('div#fitmix-container').hide();
}

function show() {
    fitmix.style.display = 'flex';
    $('div#fitmix-container').show();
}

function openVto() {
    fitmixInstance.setFrame('8053672909258')
    fitmixInstance.startVto('live')
    show()
}

function stopVto() {
    fitmixInstance.stopVto()
}


$(document).ready(function () {
    $(document).on('click', '.try-it', function () {
        // Find the selected radio button
        var selectedProduct = $('input[name="collection"]:checked');
        // console.log(selectedProduct);

        if (selectedProduct.length > 0) {
            // Get the parent product item div
            var productItem = selectedProduct.closest('.product-item.pro-popup');

            // Get the SKU from the data attribute
            var sku = productItem.data('sku');
            console.log(sku);

            if ($('#shopify-section-convenience-step2 #step2.visible').length) {
                sku = $('#step2 .checkbox input:checked').data('sku');
            }

            if (sku) {
                fitmixInstance.setFrame(`${sku}`)
                fitmixInstance.startVto('live')
                show()

                // Append close button after a slight delay to ensure #fitmix-container-box exists
                setTimeout(function () {
                    // Check if button already exists to avoid duplicates
                    if (!$('#fitmixPopupIntegrationMenu').length) {
                        $('#fitmix-container-box').append(`
                            <button id="fitmixPopupIntegrationMenu" onclick="stopVto()" style="position: absolute; cursor: pointer; height: 28px; width: 28px; right: -14px; top: -14px; background: white; border-radius: 50px; box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 2px 0px; display: grid; place-content: center; border: none; padding: 0px;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" stroke="currentColor" style="color:black; width: 14px; height: 14px;">
                                <path stroke-linecap="round" d="m1 1 8 8M1 9l8-8"></path>
                            </svg>
                            </button>
                        `);

                        // Add click handler for the close button
                        $('#fitmixPopupIntegrationMenu').on('click', function () {
                            fitmixInstance.closeVto();
                        });
                    }
                }, 2000); // 300ms delay to ensure container is ready
            } else {
                stopVto();
                errorModal("Not Available for this product.");
            }
        }
    });
});